// import { DashboardOutlined, Person, Search, BusinessIcon, WorkIcon, SearchIcon, ModeStandbyIcon, CalendarMonthIcon, StorageIcon, ThumbUpIcon } from '@mui/icons-material';

//import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
//import { CalculateOutlined } from '@mui/icons-material';
//import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
//import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
// import Forum from '@mui/icons-material/Forum';
// import Analytics from '@mui/icons-material/Analytics';
// import FolderOpen from '@mui/icons-material/FolderOpen';
// import BorderColor from '@mui/icons-material/BorderColor';
//import Search from '@mui/icons-material/Search';
// import Forum from '@mui/icons-material/Forum';
// import Analytics from '@mui/icons-material/Analytics';
// import FolderOpen from '@mui/icons-material/FolderOpen';
// import BorderColor from '@mui/icons-material/BorderColor';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
//import ModeStandbyIcon from '@mui/icons-material/ModeStandby';
//import Person from '@mui/icons-material/Person';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import WorkIcon from '@mui/icons-material/Work';

import { DrawCompteEntrepriseIcons } from '../../../data/SVGs';
//import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';

const navbarListAdmin = [
    //{
    //    icon: Search,
    //    desc: 'Search',
    //    secondDesc: '',
    //    badge: 0,
    //    subList: [],
    //},
    {
        icon: HomeOutlinedIcon,
        desc: 'Dashboard',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: ''
    },
    {
        icon: PersonOutlineOutlinedIcon,
        desc: 'Mon Compte',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Profil personnel',
                badge: 0,
                link: 'profilPersonnel'
            },
            {
                desc: 'Paramètres de compte',
                badge: 0,
                link: 'parametreCompte'
            },
            //{
            //    desc: 'Messages',
            //    badge: 10,
            //    link: 'conversation'
            //},

            //{
            //    desc: 'Se déconnecter',
            //    badge: 11,
            //    link: 'deconnecter'
            //},
        ],
    },
    {
        icon: DrawCompteEntrepriseIcons,
        desc: 'High Tech Hires',
        secondDesc: '',
        badge: 0,
        subList: [{
            desc: 'Statistiques',
            badge: 0,
            link: 'statistiques'
        },
        //{
        //    desc: 'Paramètres de compte',
        //    badge: 0,
        //    link: 'parametreCompte'
        //},
        {
            desc: 'Collaborateurs HTH',
            badge: 0,
            link: 'collaborateurHTH'
        },
        //masquer v0
        //{
        //    desc: 'Notifications',
        //    badge: 0,
        //    link: 'notifications'
        //},
        {
            desc: 'Simulateur',
            badge: 0,
            link: 'calculationSimulator'
        },

        ],
    },
    {
        icon: AssignmentIndOutlinedIcon,
        desc: 'Gestion des Experts',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'gestionExperts'
    },
    {
        icon: ApartmentOutlinedIcon,
        desc: 'Gestion des Clients',
        // secondDesc: '',
        //badge: 2,
        subList: [],
        link: 'gestionClient'
    },
    {
        icon: ApartmentOutlinedIcon,
        desc: 'Gestion des Esn',
        // secondDesc: '',
        //badge: 2,
        subList: [],
        link: 'gestionEsn'
    },

    {
        icon: WorkIcon,
        desc: 'Gestion des candidatures',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Appels d\'offres',
                badge: 0,
                link: 'aos'
            },
            {
                desc: 'CVThèque',
                badge: 0,
                link: 'AllDossiers'
            },
            {
                desc: 'Gestion des RDV',
                badge: 0,
                link: 'gestionRDV'
            },
        ],
    },
    {
        icon: InventoryOutlinedIcon,
        desc: 'Gestion des missions',
        secondDesc: '',
        badge: 0,
        subList: [
            //{
            //    desc: 'createMission',
            //    badge: 0,
            //    link: 'createMission'
            //},
            {
                desc: 'Missions et BDC',
                badge: 0,
                link: 'mission'
            },
            {
                desc: 'CRA',
                badge: 0,
                link: 'AllCras'
            },
            {
                desc: 'Facturation',
                badge: 0,
                link: 'AllFactures'
            },
            //{
            //    desc: 'Liste des CRA',
            //    badge: 0,
            //    link: 'CRAs'
            //},
        ],
    },
    //traitement du validation kbis et contrat dans le fichier allusers
    {
        icon: FactCheckOutlinedIcon,
        desc: 'Demandes à valider',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Documents administratifs',
                badge: 0,
                link: 'documentAdministratifs'
            },
            {
                desc: 'Interruptions de mission',
                badge: 0,
                link: 'InterruptionsMissions'
            },
            //masquer pour v0
            //{
            //    desc: 'Suppressions de compte',
            //    badge: 0,
            //    link: 'suppressionComptes'
            //},
        ],
    },
    //{
    //    icon: CalculateOutlined,
    //    desc: 'simulateur de calcul',
    //    // secondDesc: '',
    //    badge: 0,
    //    subList: [],
    //    link: 'calculationSimulator'
    //},
];

export const navbarListAdminChargeRecrutement = [
    {
        icon: PersonOutlineOutlinedIcon,
        desc: 'Mon Compte',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Profil personnel',
                badge: 0,
                link: 'profilPersonnel'
            },
            {
                desc: 'Paramètres de compte',
                badge: 0,
                link: 'parametreCompte'
            },
            //{
            //    desc: 'Messages',
            //    badge: 10,
            //    link: 'conversation'
            //},

            //{
            //    desc: 'Se déconnecter',
            //    badge: 11,
            //    link: 'deconnecter'
            //},
        ],
    },
    {
        icon: DrawCompteEntrepriseIcons,
        desc: 'High Tech Hires',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Collaborateurs HTH',
                badge: 0,
                link: 'collaborateurHTH'
            },
            {
                desc: 'Simulateur',
                badge: 0,
                link: 'calculationSimulator'
            },

        ],
    },
    {
        icon: AssignmentIndOutlinedIcon,
        desc: 'Gestion des Experts',
        secondDesc: '',
        badge: 0,
        subList: [],
        link: 'gestionExperts'
    },
    {
        icon: ApartmentOutlinedIcon,
        desc: 'Gestion des Clients',
        // secondDesc: '',
        //badge: 2,
        subList: [],
        link: 'gestionClient'
    },

    {
        icon: WorkIcon,
        desc: 'Gestion des candidatures',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Appels d\'offres',
                badge: 0,
                link: 'aos'
            },
            {
                desc: 'CVThèque',
                badge: 0,
                link: 'AllDossiers'
            },
            {
                desc: 'Gestion des RDV',
                badge: 0,
                link: 'gestionRDV'
            },
        ],
    },
    {
        icon: InventoryOutlinedIcon,
        desc: 'Gestion des missions',
        secondDesc: '',
        badge: 0,
        subList: [
            //{
            //    desc: 'createMission',
            //    badge: 0,
            //    link: 'createMission'
            //},
            {
                desc: 'Missions et BDC',
                badge: 0,
                link: ''
            },
            {
                desc: 'CRA',
                badge: 0,
                link: 'AllCras'
            },
            {
                desc: 'Facturation',
                badge: 0,
                link: 'AllFactures'
            },
            //{
            //    desc: 'Liste des CRA',
            //    badge: 0,
            //    link: 'CRAs'
            //},
        ],
    },
    //traitement du validation kbis et contrat dans le fichier allusers
    {
        icon: FactCheckOutlinedIcon,
        desc: 'Demandes à valider',
        secondDesc: '',
        badge: 0,
        subList: [
            {
                desc: 'Documents administratifs',
                badge: 0,
                link: 'documentAdministratifs'
            },
            {
                desc: 'Interruptions de mission',
                badge: 0,
                link: 'InterruptionsMissions'
            },
            //masquer pour v0
            //{
            //    desc: 'Suppressions de compte',
            //    badge: 0,
            //    link: 'suppressionComptes'
            //},
        ],
    },
    //{
    //    icon: CalculateOutlined,
    //    desc: 'simulateur de calcul',
    //    // secondDesc: '',
    //    badge: 0,
    //    subList: [],
    //    link: 'calculationSimulator'
    //},
];

export default navbarListAdmin;
